module.exports = __webpack_public_path__ + "img/home_newbie_act_pop_c.366f1d9a.png";